var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoloLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 55,
    viewBox: "0 0 114 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1753 16.5928L37.5754 22.1483H43.6497L46.2469 16.5928H40.1753Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.592 9.44482H43.5204L40.9206 15.0004H46.9922L49.592 9.44482Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1599 33.7246V23.7399H21.0729C21.0729 25.2127 21.6557 26.6251 22.6931 27.6664C23.7305 28.7078 25.1375 29.2928 26.6045 29.2928V45.5522H32.663L42.8701 23.7373H36.8117L32.1599 33.7246Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1595 15.0011C32.1595 11.9338 29.4122 9.44824 26.3645 9.44824H7.3595C7.3595 10.921 7.94229 12.3334 8.97967 13.3747C10.017 14.4161 11.424 15.0011 12.8911 15.0011H32.1595Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1598 16.5928H14.0846C14.0846 18.0655 14.6674 19.4779 15.7048 20.5193C16.7421 21.5606 18.1491 22.1457 19.6162 22.1457H32.1572L32.1598 16.5928Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7058 23.7402L57.6555 38.1381C57.5409 38.6193 57.2732 39.05 56.893 39.3649C56.5128 39.6798 56.0407 39.8618 55.5482 39.8833H52.0765C51.8606 39.8925 51.6456 39.8501 51.4492 39.7595C51.2528 39.669 51.0806 39.5329 50.9468 39.3625C50.8131 39.192 50.7216 38.9922 50.6798 38.7793C50.6381 38.5664 50.6473 38.3467 50.7068 38.1381L53.7544 23.7402H48.1043L44.6641 39.9943C44.0135 43.0643 45.9654 45.5472 49.0262 45.5472H56.1962C59.2544 45.5472 62.2547 43.0563 62.9132 39.9943L66.3533 23.7402H60.7058Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6904 22.1483L67.8678 16.5928H62.2177L61.0428 22.1483H66.6904Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8404 9.44482H56.6704C53.6148 9.44482 50.6119 11.933 49.9561 14.9977H68.2051C68.8505 11.933 66.9065 9.44482 63.8404 9.44482Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0914 22.1483L55.2662 16.5928H49.6187L48.4413 22.1483H54.0914Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0096 9.44482H73.2067L72.0319 15.0004H77.8348L79.0096 9.44482Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9832 23.7402H70.1882L66.7454 39.9996C66.6038 40.6693 66.613 41.3623 66.7723 42.028C66.9316 42.6937 67.2369 43.3153 67.666 43.8474C68.0951 44.3796 68.6372 44.8088 69.2526 45.1038C69.8681 45.3987 70.5414 45.5521 71.2234 45.5525H79.5761L80.7536 39.7352H74.4712C74.2388 39.7353 74.0092 39.6832 73.7994 39.5827C73.5896 39.4821 73.405 39.3356 73.2589 39.1541C73.1129 38.9725 73.0093 38.7604 72.9556 38.5333C72.9019 38.3063 72.8996 38.07 72.9487 37.8419L75.9832 23.7402Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.498 16.5928H71.6951L70.5177 22.1483H76.3206L77.498 16.5928Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7601 38.1381C95.6455 38.6193 95.3778 39.05 94.9976 39.3649C94.6174 39.6798 94.1453 39.8618 93.6529 39.8833H90.1811C89.9652 39.8925 89.7502 39.8501 89.5538 39.7595C89.3574 39.669 89.1852 39.5329 89.0514 39.3625C88.9177 39.192 88.8262 38.9922 88.7844 38.7793C88.7427 38.5664 88.7519 38.3467 88.8114 38.1381L91.859 23.7402H86.2115L82.7688 39.9943C82.1181 43.0643 84.0726 45.5472 87.1308 45.5472H94.3008C97.359 45.5472 100.359 43.0563 101.018 39.9943L104.458 23.7402H98.8104L95.7601 38.1381Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1479 22.1483H104.795L105.973 16.5928H100.323L99.1479 22.1483Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3734 16.5928H87.7233L86.5485 22.1483H92.196L93.3734 16.5928Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.94 9.44482H94.7777C91.7196 9.44482 88.7193 11.933 88.0608 14.9977H106.31C106.945 11.933 105.003 9.44482 101.94 9.44482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoloLogoWhite);
export default __webpack_public_path__ + "static/media/volo_logo_white.abab71bba01d4de27fe072e6f13b6cc2.svg";
export { ForwardRef as ReactComponent };